import * as actions from './sensorActions';

const initialState = {
    readings: [],
    stats: null,
    isLoading: false,
    isLoadingStats: false,
    error: null,
    statsError: null
};

const sensorReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch sensor readings
        case actions.FETCH_SENSOR_READINGS.REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case actions.FETCH_SENSOR_READINGS.SUCCESS:
            return {
                ...state,
                readings: action.payload,
                isLoading: false,
                error: null
            };
        case actions.FETCH_SENSOR_READINGS.FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        // Fetch sensor stats
        case actions.FETCH_SENSOR_STATS.REQUEST:
            return {
                ...state,
                isLoadingStats: true,
                statsError: null
            };
        case actions.FETCH_SENSOR_STATS.SUCCESS:
            return {
                ...state,
                stats: action.payload,
                isLoadingStats: false,
                statsError: null
            };
        case actions.FETCH_SENSOR_STATS.FAILURE:
            return {
                ...state,
                isLoadingStats: false,
                statsError: action.payload
            };

        // Clear sensor data
        case actions.CLEAR_SENSOR_DATA:
            return initialState;

        default:
            return state;
    }
};

export default sensorReducer;
